import React from "react";

/**
 * تنظيف نصّ البلوكات: إزالة المسافات الزائدة من بداية/نهاية كلّ سطر
 * مع الحفاظ على فواصل الأسطر والفراغات بين المقاطع.
 * السبب: النصوص الملصوقة قد تحمل مسافات تكسر التمركز على الموبايل مع whitespace-pre-line.
 */
export function cleanBlockText(input?: string | null): string {
  if (!input) return "";
  return input
    .replace(/\r\n?/g, "\n")
    .split("\n")
    .map((line) => line.replace(/[ \t\u00A0\u200e\u200f]+/g, " ").trim())
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/** تحويل `**نصّ**` إلى خطّ عريض بلا مكتبة markdown. */
export function renderBoldText(text: string): React.ReactNode[] {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    const m = /^\*\*([^*]+)\*\*$/.exec(part);
    if (m) {
      return (
        <strong key={i} className="font-semibold">
          {m[1]}
        </strong>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
